var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWrite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 87.554,
    height: 75.061,
    viewBox: "0 0 87.554 75.061",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Union_1",
    x: 0,
    y: 0,
    width: 87.554,
    height: 75.061,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON",
    transform: "translate(-11.704 -18.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "writing-tool_1_",
    "data-name": "writing-tool (1)",
    transform: "translate(20.704 24.155)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Union_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1-2",
    "data-name": "Union 1",
    d: "M61.4,55.019V24.455h6.114a2.038,2.038,0,0,1,2.038,2.038V51.958a2.038,2.038,0,0,1-.825,1.638l-4.377,3.246A2.033,2.033,0,0,1,61.4,55.019ZM26.487,54v-1.02H29.1l1.412.72c.644.318,1.318.567,1.982.842a3.016,3.016,0,0,1-2.948,2.514A3.057,3.057,0,0,1,26.487,54ZM16.3,54V52.779a10.316,10.316,0,0,0,2.038.205h4.076V54A3.057,3.057,0,0,1,16.3,54Zm-11.358.952a2.036,2.036,0,0,1-.783-2.25l1.837-6.176a2.013,2.013,0,0,1,.283-.589L8.189,43.21A10.159,10.159,0,0,0,12.473,51.1L7.322,54.923a2.037,2.037,0,0,1-2.383.032Zm25.135-6.047H18.336a6.113,6.113,0,1,1,0-12.226H28.875a16.058,16.058,0,0,0,11.279-4.674,2.038,2.038,0,1,0-2.882-2.882,11.922,11.922,0,0,1-6.607,3.3l9.97-14.241,12.949,6.27h3.74V50.172a29.552,29.552,0,0,1-12.5,2.812A30.174,30.174,0,0,1,30.075,48.908ZM.639,35.986,11.87,18.3a6.088,6.088,0,0,1,2.726-2.33l7.752-3.367a6.457,6.457,0,0,1,2.5-.287L2.935,43.606c-.049.071-.065.159-.113.233A6.1,6.1,0,0,1,.639,35.986ZM31.992,9.216l6.676,4.675L25.564,32.6H18.335a10.064,10.064,0,0,0-3.093.533Zm2.338-3.337L37.835.869a2.036,2.036,0,0,1,2.838-.5l3.339,2.336a2.039,2.039,0,0,1,.5,2.84l-3.507,5.008Z",
    transform: "translate(9 6)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWrite);
export default __webpack_public_path__ + "static/media/icon-write.7addf514be83fb3bc28d6c939f1db27a.svg";
export { ForwardRef as ReactComponent };